module.exports = __webpack_public_path__ + "OpenSource1.png?bd56a25bd868a76084fdb5b6a2a7483f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/OpenSource1.png
// module id = 233
// module chunks = 0